import { render, staticRenderFns } from "./SettingsTeam.vue?vue&type=template&id=78b2bb66&scoped=true&"
import script from "./SettingsTeam.vue?vue&type=script&lang=js&"
export * from "./SettingsTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b2bb66",
  null
  
)

export default component.exports